import React from 'react'

import Partner1Img from './img/partner_1.png'
import Partner2Img from './img/partner_2.png'
import Partner3Img from './img/partner_3.png'
import Partner4Img from './img/partner_4.png'
import Partner5Img from './img/partner_5.png'

export const NoxsysPartners: React.FC = () => {
    return (
        <div className="w-full lg:w-[940px]">
            <h1 className="font-bold text-2xl mt-10 text-center">
                С нами уже работают
            </h1>
            <div className="flex flex-col md:flex-row flex-wrap place-content-center">
                <img src={Partner1Img} />
                <img src={Partner2Img} />
                <img src={Partner3Img} />
                <img src={Partner3Img} />
                <img src={Partner4Img} />
                <img src={Partner5Img} />
                <img src={Partner5Img} />
            </div>
        </div>
    )
}
